import http from "../../../../core/services/http.service";

const IncrementsService = {
  getIncrements(auction_uuid, params = null) {
    return http.get(`/api/v1/auctions/${auction_uuid}/increments/`, {params});
  },
  postIncrements(auction_uuid, data) {
    return http.post(`/api/v1/auctions/${auction_uuid}/increments/`, data);
  },
  postLotIncrements(lot_uuid, data) {
    return http.post(`/api/v1/lots/${lot_uuid}/increments/`, data);
  },
};

export default IncrementsService;
